<template>
  <div :class="[landscape ? 'item' : 'item-portrait']">
    <div class="wrapper">
      <img class="sc-part1" src="../../assets/sc_part1.png" alt="">
      <img class="sc-part2" src="../../assets/sc_part2.png" alt="">
      <img class="sc-part3" src="../../assets/sc_part3.png" alt="">
      <img class="sc-part4" src="../../assets/sc_part4.png" alt="">
      <img class="sc-part5" src="../../assets/sc_part5.png" alt="">
      <img class="sc-part6" src="../../assets/sc_part6.png" alt="">
      <img class="sc-part7" src="../../assets/sc_part3.png" alt="">
      <img class="sc-text" src="../../assets/sc_text.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: ['landscape']
}
</script>

<style lang="scss" scoped>
@import '../../Global.scss';
@import './Dashboard.scss';
$width: 7.6rem;
.item {
  width: $width;
  animation: slideInRight 1s 1s linear;
  animation-fill-mode: both;
}
.item-portrait {
  .wrapper {
    width: $width;
  }
}
.sc-part1 {
  width: 3.305rem;
  height: 1.96rem;
  position: relative;
  left: .2rem;
  bottom: .5rem;
}
.sc-part2 {
  width: .71rem;
  height: .71rem;
  left: 1.95rem;
  top: 2.2rem;
  animation: rolling 5s infinite linear;
}
.sc-part3 {
  width: .37rem;
  height: .37rem;
  left: 1.7rem;
  top: 1.9rem;
  animation: rolling 5s infinite linear reverse;
}
.sc-part4 {
  width: .45rem;
  height: .31rem;
  position: relative;
  left: 0rem;
  top: 1.8rem;
  opacity: 0;
  animation: flash1 5s infinite linear;
}
.sc-part5 {
  width: .95rem;
  height: .65rem;
  left: 2.35rem;
  top: .8rem;
  opacity: 0;
  animation: flash1 5s 2s infinite linear;
  // animation: zoomOut 2.5s infinite alternate linear;
}
.sc-part6 {
  width: .845rem;
  height: .42rem;
  position: relative;
  left: 3.4rem;
  top: 2.2rem;
  opacity: 0;
  animation: flash1 5s 3s infinite linear;
  // animation: rolling 5s infinite linear;
}
.sc-text {
  width: 2.65rem;
  height: 3rem;
  left: 4.5rem;
  bottom: .4rem;

}
.sc-part7 {
  @extend .sc-part3;
  left: 1.7rem;
  top: 1.9rem;
  left: .32rem;
  top: 2.65rem;
  animation: rolling 5s infinite linear;
}
@keyframes rolling {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes flash1 {
  from, 4%, 8%, 80%, to {
    opacity: 0;
  }

  2%, 6%, 10%, 75% {
    opacity: 1;
  }
}
@keyframes slideInRight {
  from {
    transform: translate(17rem);
  }
  to {
    transfrom: tranalate(0rem);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Part3.vue